import { Component, inject, OnInit } from '@angular/core';
import { Auth } from '../../../services/auth';
import { Help } from '../help/help';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.html',
  styleUrl: './footer.less'
})
export class Footer implements OnInit {
  user: any;
  private authService = inject(Auth);
  constructor(private dialog: MatDialog) {
    this.authService.user.subscribe((x: any) => this.user = x);
  }

  ngOnInit(): void {

  }

  viewHelp() {
    const helpDialog = this.dialog.open(Help, {
      disableClose: true,
      height: '500px',
      width: '500px',
      panelClass: 'custom-dialog-container',
      hasBackdrop: true,
      autoFocus: false

    });

    helpDialog.afterClosed().subscribe({

    })
  }
}
